import { refreshConnectedAccountAccessToken } from '../services/refreshConnectedAccountAccessToken';
import { ConnectedAccountResponse } from '../contracts/ConnectedAccountResponse';
import { ErrorResponse } from '../contracts/ErrorResponse';

export async function getAccessToken(
    id: string
): Promise<ConnectedAccountResponse | ErrorResponse> {
    // To do: add token cache and refresh the access token if expired
    var redirectUrl = window.location.origin + '/mail/oauthRedirect.html'; // to do: redirect url need to be constructed and returned from server call
    return await refreshConnectedAccountAccessToken(id, redirectUrl);
    // to do: error handling
}
